module.exports = __webpack_public_path__ + "media/images/icon-clock-fae002ca346a940ef949860991b302dc.png";